export const requiredNumberMsg = 'This field required type of number'
export const requiredMsg = 'This field is required'
